/**
 * SpecTree Toolbox type scale and text greys (epic PI-SPEC-SW-E287, feature
 * PI-SPEC-SW-1458; UX-PM-27 and UX-PM-28 in docs/analysis/toolbox-ux/03-evaluation.md §8.3).
 *
 * Design scale (Claude Design frame 1a):
 *   .h1 page title  22 px / 600 Golos Text   TOOLBOX_PAGE_TITLE
 *   .h2             16 px
 *   .h3             14 px
 *   body / content  13 px                    TOOLBOX_TEXT.content
 *   meta            12 px                    TOOLBOX_TEXT.meta (text-xs)
 *   eyebrow         11 px uppercase .08em #A1A1AA
 *   chips, kbd      11 px
 *   rail labels, project label 10.5 px; badges 10 px
 *
 * Classifying a run of text:
 *   - Content (at least 13 px): sentences a person reads — notices, explanations,
 *     empty states, error and help text, brief prose, list item titles, dialog body text.
 *   - Meta (12 px, `text-xs`): dates, IDs, counts, state lines under rows, small
 *     captions next to a control, timestamps.
 *   - 11 px and below only for eyebrows (uppercase labels), table headers, chips,
 *     badges, kbd, rail labels and the project label.
 *   When unsure: 13 px for a full sentence, 12 px for a fragment.
 *
 * Greys: the darkest text grey is the design's `.faint` #8B8B94; muted text is
 * #A1A1AA (`text-muted-foreground`). #71717A (zinc-500) and darker measure about
 * 4:1 or less on the near-black background and fail WCAG 2.2 AA 1.4.3, so they are
 * never used for text. components/grooming/__tests__/toolbox-type-contrast.test.ts
 * enforces the greys and the page-title size across the Toolbox source.
 */

/** Every Toolbox page title (`.h1`). Pane headings that are h1 for accessibility do not use it. */
export const TOOLBOX_PAGE_TITLE = "font-display text-[22px] font-semibold leading-tight tracking-[-0.01em]";

export const TOOLBOX_TEXT = {
  /** Sentences a person reads. */
  content: "text-[13px]",
  /** Dates, IDs, counts, state lines, captions next to a control. */
  meta: "text-xs",
  /** Uppercase section labels. */
  eyebrow: "text-[11px] font-semibold uppercase tracking-[0.08em] text-muted-foreground",
  /** The darkest allowed text grey (`.faint`). */
  faint: "text-[#8B8B94]",
} as const;
